import React from 'react';
import classnames from 'classnames';

import NavItem from './NavItem';
import ResourcePopoverNav from './ResourcePopoverNav';
import {
  useNavigationState,
  useNavigationDispatch,
} from '../contexts/navigation';

const navItems = [
  {
    label: 'Product',
    items: [
      {
        icon: 'GRID',
        label: 'What is Headless CMS?',
        to: '/academy/headless-cms',
      },
      {
        label: 'For Engineering Teams',
        to: '/for-engineering',
      },
      {
        icon: 'WAND',
        label: 'GraphCMS Features',
        to: '/features',
      },
      {
        icon: 'INCOMPLETE_GRID',
        label: 'Compare Headless CMS',
        to: '/headless-cms-comparison',
      },
      {
        icon: 'GLOBE',
        label: 'Implementation Partners',
        to: '/partners',
      },
      {
        icon: 'CONNECT',
        label: 'Technology Ecosystem',
        to: '/ecosystem-partners',
      },
      {
        icon: 'STAR_OUTLINE',
        label: 'For High Growth Companies',
        to: '/content-management-that-scales',
      },
      {
        icon: 'LAYERS',
        label: 'For Modernizing Companies',
        to: '/for-modernizing-companies',
      },
      {
        icon: 'BUILDINGS',
        label: 'For Enterprise Companies',
        to: '/enterprise-headless-cms',
      },
      {
        icon: 'PRIVACY',
        label: 'Security & Compliance',
        to: '/security-and-compliance',
      },
    ],
  },
  {
    label: 'Solutions',
    columns: [
      {
        label: 'Use Cases',
        items: [
          {
            icon: 'LAPTOP',
            label: 'Marketing Websites and SEO',
            to: '/use-cases/marketing-websites-and-seo',
          },
          {
            icon: 'LAYERS',
            label: 'Application Content',
            to: '/use-cases/application-content',
          },
          {
            icon: 'GRID',
            label: 'Federated Content Hub',
            to: '/use-cases/content-federation',
          },
          {
            icon: 'SPEECH',
            label: 'Content Localization',
            to: '/use-cases/content-localization',
          },
          {
            icon: 'CART',
            label: 'Agile eCommerce',
            to: '/use-cases/agile-ecommerce',
          },
          {
            icon: 'GLOBE',
            label: 'Portals and Intranets',
            to: '/use-cases/portals',
          },
          {
            icon: 'SQUARE_PLUS',
            label: 'All Solutions',
            to: '/use-cases',
          },
        ],
      },
      {
        label: 'Customers',
        items: [
          {
            icon: 'STAR_OUTLINE',
            label: 'Case Studies',
            to: '/case-studies',
          },
          {
            icon: 'SHOPPING',
            label: 'eCommerce / Retail',
            to: '/customers/ecommerce-and-retail',
          },
          {
            icon: 'AIRPLANE',
            label: 'Travel / Hospitality',
            to: '/customers/travel-and-hospitality',
          },
          {
            icon: 'MONEY',
            label: 'Fintech / Insurance',
            to: '/customers/fintech-and-insurance',
          },
          {
            icon: 'CODE',
            label: 'Startups / Tech',
            to: '/customers/startups-and-tech',
          },
          {
            icon: 'BOOK',
            label: 'Media / Publications',
            to: '/customers/media-and-publications',
          },
          {
            icon: 'SQUARE_PLUS',
            label: 'All Customers',
            to: '/customers',
          },
        ],
      },
    ],
  },
  {
    label: 'Resources',
    Component: ResourcePopoverNav,
    items: [
      {
        icon: 'EDIT',
        label: 'Blog',
        to: '/blog',
      },
      {
        icon: 'BOOKMARK',
        label: 'Academy',
        to: '/academy',
      },
      {
        icon: 'CODE',
        label: 'Documentation',
        to: '/docs',
      },
      {
        icon: 'BOOK',
        label: 'User Guides',
        to: '/user-guides',
      },
      {
        icon: 'CONTENT',
        label: 'Examples',
        to: '/docs/develop/code-examples',
      },
      {
        icon: 'ARCHIVE',
        label: 'Resources Hub',
        to: '/resources',
      },
      {
        icon: 'CALENDAR',
        label: 'Events',
        to: '/events',
      },
    ],
  },
  {
    label: 'Pricing',
    to: '/pricing',
  },
];

export default function MainNav() {
  const { isOpen } = useNavigationState();
  const { closeNav } = useNavigationDispatch();
  const baseNav = 'main-nav flex-col w-auto px-4';
  const mainNavClass = classnames(
    baseNav,
    'lg:flex-row lg:items-center lg:justify-center',
    {
      'hidden lg:flex': !isOpen,
      'flex border-gray-300 border-t mt-6 pt-4 border-transparent left-0 right-0 bottom-0 lg:mt-0 lg:pt-0 lg:border-none h-screen lg:overflow-y-visible': isOpen,
    }
  );

  return (
    <nav className={mainNavClass}>
      <ul role="menubar" className="justify-center lg:flex lg:flex-row">
        {navItems.map((item, index) => {
          return <NavItem key={index} {...item} handleOnClick={closeNav} />;
        })}
      </ul>
    </nav>
  );
}
